//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  components: {
      cmBlank,cmLoadmore
  },
  
  data () {
    return {
      blankShow:false,
      loadStatus:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      phone:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      list:[],
    }
},
created(){
    this.phone = this.$route.query.phone || '';
},
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.loadmore();
    },
    searchOrder(orderNo){
        this.$router.push({name:'searchOrder',params:{code:orderNo}})
    },
    resetSearch(){
        this.phone = '';
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.loadmore();
        this.searchPop = false;
    },
    searchSubmit(){
      this.lastId = 0;
      this.pageFlag = 2;
      this.list = [];
      this.loadmore();
      this.searchPop = false;
    },
    getList(){
        if(!this.phone){
            return false;
        }
        this.$api.washCode({last_id:this.lastId,page_flag:this.pageFlag,type:2,phone:this.phone}).then((res)=>{
            if(res){
                if(!this.lastId){
                    this.blankShow = res.data.length > 0 ? false : true;
                }
                this.hasNext = res.hasNext;
                this.lastId = res.lastId;
                res.data.forEach((item)=>{
                    this.list.push(item);
                });
            }
        }) 
    },
    barOrder(code){
        this.$router.push({name:'barOrder',params:{code:code}})
    },
    loadmore(){
        if(this.lastId > 0 && !this.hasNext){
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '没有更多了。。。'
            return ;
        }
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '正在加载。。。';
        this.getList();
        setTimeout(()=>{
           if(this.blankShow){
                this.busy = true;
                this.loadStatus = false;
                this.loadmoreText = '没有更多了。。。'
            }else{
                if(this.hasNext > 0){
                    this.loadStatus = false;
                    this.busy = false;
                }else{
                    this.busy = true;
                    this.loadStatus = true;
                    this.loadmoreText = '没有更多了。。。'
                }
            }
        },1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/recordPhoneList.vue